import {useRouter} from 'next/router';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import {setForgotPasswordEmail} from '@/src/app/store/forgotPassword/forgotPasswordSlice';
import useLoading from '@/src/hooks/useLoading';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import ForgotPasswordLayout from '../components/ForgotPasswordLayout';
import resetPasswordAction from '../utils/resetPasswordAction';

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const {isLoading, setLoading} = useLoading();
  const {push} = useRouter();
  const {FORGOT_PASSWORD_PENDING_ROUTE} = useRoutePaths();

  const handleSubmit = useCallback(async (values, {setFieldError}) => {
    setLoading(true);

    const {status, responseBody} = await resetPasswordAction(values.email);

    setLoading(false);

    if (status === RESPONSE_STATUSES.SUCCESS) {
      dispatch(setForgotPasswordEmail(values.email));

      push(FORGOT_PASSWORD_PENDING_ROUTE.getLink());
    }

    if (
      responseBody &&
      responseBody.error &&
      typeof responseBody.error === 'object'
    ) {
      for (const key in responseBody.error) {
        if (Object.prototype.hasOwnProperty.call(responseBody.error, key)) {
          setFieldError(key, responseBody.error[key]);
        }
      }
    }
  }, []);

  return (
    <ForgotPasswordLayout handleSubmit={handleSubmit} isLoading={isLoading} />
  );
};

export default ForgotPassword;
